
import { Component, Vue } from 'vue-property-decorator';
import Benp01Modal from '@/modals/Benp01Modal.vue';
import Cafe01Modal from '@/modals/Cafe01Modal.vue';
import ErrorForApiComponent from '@/components/ErrorForApiComponent.vue';
import Subs01Modal from '@/modals/Subs01Modal.vue';
import OrderApiConfig from '@/api/OrderApiConfig';
import {
  DPApi,
  JpCoBenefitoneBsSubsidyDtoErrorData,
  PostConfirmSelectPayRequest,
  JpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequest,
} from '@/openapi/order';
import EnvRepository from '@/repository/EnvRepository';
import store from '@/store';
import ApiService from '@/services/ApiService';

type OrderConfirmType = {
  familySerialNumber: number;
  familyName: string;
  familyNameKana: string;
  firstName: string;
  firstNameKana: string;
  age: number;
  customerNo: string;
  menuBasicInfo: {
    menuNo: string;
    menuNm: string;
    planNm: string;
    categoryInfomation: {
      catSmlClassNm: string;
    };
  };
  customer?: {
    familyName: string;
    firstName: string;
  };
  planBasicInfo: {
    planImages: {
      imageUrl: string;
    }[];
  };
  payMthdInfo: {
    payMthdList: {
      payMthdDiv: string;
    }[];
    benepoUseFlag: string;
  };
  cautions: {
    title: string;
    content: string;
    infoLev: string;
    linkUrl: string;
    linkNm: string;
  }[];
  grantedBenepo?: number;
  canSubsidy: boolean;
  canSubsidyRequired: boolean;
  canCafePoint: boolean;
  orderSite: number;
  orderSubsidyFlag: boolean;
  orderCafeFlag: boolean;
  orderBenepoFlag: boolean;
  orderPayFlag: boolean;
  subsidyRequiredAmountTotal: number;
  subsidyNoRequiredAmountTotal: number;
  benepoAmountTotal: number;
  cafeUsePoint: number;
  subTotal: number;
  subsidyAmountTotal: number;
  billingAmount: number;
  canUsePoint: number;
  trySubsidyTransactionId: string;
  doneApplySubsidy: boolean;
  doneApplyCafe: boolean;
  contractCafe: boolean;
};

@Component({
  components: {
    Benp01Modal,
    Cafe01Modal,
    ErrorForApiComponent,
    Subs01Modal,
  },
  filters: {
    comma(value?: number) {
      if (!value) return 0;
      return value.toLocaleString();
    },
  },
})
export default class Conf01View extends Vue {
  //* ***********************************************************************************/
  // Data
  //* ***********************************************************************************/
  commonErrorResponse: JpCoBenefitoneBsSubsidyDtoErrorData = {
    errorCode: '',
    errorDetail: '',
  };

  showBenp01Modal = false;

  showCafe01Modal = false;

  showSubs01Modal = false;

  resGetConfirm: OrderConfirmType = null;

  selectedPaymentMethod = '';

  orderSite: number = null;

  //* ***********************************************************************************/
  // Computed
  //* ***********************************************************************************/
  get disabledBenepo(): boolean {
    if (!this.resGetConfirm.canUsePoint) return true;

    return this.resGetConfirm.canUsePoint === 0;
  }

  get disabledBenepo2(): boolean {
    if (this.resGetConfirm.payMthdInfo === undefined || this.resGetConfirm.payMthdInfo.benepoUseFlag === undefined) return false;
    return Number(this.resGetConfirm.payMthdInfo?.benepoUseFlag) === 0;
  }

  // ベネポ非活性条件パターン1
  get disabledBenepo3(): boolean {
    const res: boolean | undefined =
      this.resGetConfirm.orderSubsidyFlag &&
      this.resGetConfirm.canSubsidy &&
      this.resGetConfirm.orderCafeFlag &&
      this.resGetConfirm.contractCafe &&
      this.resGetConfirm.canCafePoint &&
      this.resGetConfirm.orderBenepoFlag &&
      this.resGetConfirm.payMthdInfo.benepoUseFlag !== '0' &&
      this.resGetConfirm.canUsePoint !== 0 &&
      !this.resGetConfirm.doneApplySubsidy &&
      !this.resGetConfirm.doneApplyCafe;

    return res ?? false;
  }

  // ベネポ非活性条件パターン2
  get disabledBenepo4(): boolean {
    const res: boolean | undefined =
      this.resGetConfirm.orderCafeFlag &&
      this.resGetConfirm.contractCafe &&
      this.resGetConfirm.canCafePoint &&
      this.resGetConfirm.orderBenepoFlag &&
      this.resGetConfirm.payMthdInfo.benepoUseFlag !== '0' &&
      this.resGetConfirm.canUsePoint !== 0 &&
      !this.resGetConfirm.doneApplyCafe;

    return res ?? false;
  }

  // ベネポ非活性条件パターン7
  get disabledBenepo5(): boolean {
    const res: boolean | undefined =
      this.resGetConfirm.orderSubsidyFlag &&
      this.resGetConfirm.canSubsidy &&
      this.resGetConfirm.orderBenepoFlag &&
      this.resGetConfirm.payMthdInfo.benepoUseFlag !== '0' &&
      this.resGetConfirm.canUsePoint !== 0 &&
      !this.resGetConfirm.doneApplySubsidy;

    return res ?? false;
  }

  get disabledCafePoint(): boolean {
    return !this.resGetConfirm.canCafePoint ?? true;
  }

  get disabledCafePoint2(): boolean {
    const res: boolean | undefined = this.resGetConfirm.orderSubsidyFlag && this.resGetConfirm.canSubsidy && !this.resGetConfirm.doneApplySubsidy;

    return res ?? false;
  }

  get getPlanImageUrl(): string {
    const noImageUrl = '';
    if (
      !this.resGetConfirm?.planBasicInfo ||
      !this.resGetConfirm.planBasicInfo.planImages ||
      (this.resGetConfirm.planBasicInfo.planImages && this.resGetConfirm.planBasicInfo.planImages.length === 0)
    ) {
      return noImageUrl;
    }

    return this.resGetConfirm.planBasicInfo.planImages[0].imageUrl ?? noImageUrl;
  }

  get getSmallCategoryName(): string {
    if (!this.resGetConfirm?.menuBasicInfo || !this.resGetConfirm.menuBasicInfo.categoryInfomation) {
      return '';
    }

    return this.resGetConfirm.menuBasicInfo.categoryInfomation.catSmlClassNm ?? '';
  }

  get getMenuNumber(): string {
    if (!this.resGetConfirm?.menuBasicInfo) {
      return '';
    }

    return this.resGetConfirm.menuBasicInfo.menuNo ?? '';
  }

  get getMenuName(): string {
    if (!this.resGetConfirm?.menuBasicInfo) {
      return '';
    }
    return this.resGetConfirm.menuBasicInfo?.menuNm ?? '';
  }

  get getPlanName(): string {
    if (!this.resGetConfirm?.menuBasicInfo) {
      return '';
    }

    return this.resGetConfirm.menuBasicInfo?.planNm ?? '';
  }

  get generateRelationshipLabel(): string {
    if (!this.resGetConfirm?.familySerialNumber && this.resGetConfirm.familySerialNumber !== 0) {
      return '';
    }

    const master: { [key: number]: string } = {
      0: '本人',
      1: '家族会員一人目',
      2: '家族会員二人目',
    };

    return master[this.resGetConfirm.familySerialNumber] ?? '家族会員';
  }

  get generatePaymentMethods(): { [key: string]: string } {
    if (!this.resGetConfirm.payMthdInfo || !this.resGetConfirm.payMthdInfo.payMthdList) {
      return {};
    }

    const result: { [key: string]: string } = {};

    this.resGetConfirm.payMthdInfo.payMthdList.forEach((item) => {
      if (item.payMthdDiv) {
        let label: string | undefined;
        switch (item.payMthdDiv) {
          case '10':
            label = '銀行振込み';
            break;
          case '20':
            label = 'クレジットカード ';
            break;
          case '30':
            label = 'コンビニ決済';
            break;
          case '40':
            label = 'ロッピー';
            break;
          case '50':
            label = '全額べネポ';
            break;
          case '55':
            label = 'カフェとベネポのみ';
            break;
          case '60':
            label = '全額カフェ';
            break;
          case '70':
            label = '給与天引き';
            break;
          default:
          // do nothing
        }

        if (label) {
          result[item.payMthdDiv] = label;
        }
      }
    });

    return result;
  }

  get validSubmit(): boolean {
    return Object.keys(this.generatePaymentMethods).length === 0 || Boolean(this.selectedPaymentMethod);
  }

  get isShowCaution(): boolean {
    return this.resGetConfirm.cautions && this.resGetConfirm.cautions.length > 0;
  }

  // orderSiteが1（楽天）で支払予定額が0円の場合はお支払不可
  get isRakutenError(): boolean {
    return !!(this.resGetConfirm.orderSite === 1 && this.resGetConfirm.billingAmount === 0);
  }

  get getErrorRakuten(): string {
    return EnvRepository.getEnv().VUE_APP_RAKUTEN_NO_PAYMENT_ERROR;
  }

  //* ***********************************************************************************/
  // 初期表示
  //* ***********************************************************************************/
  mounted(): void {
    this.doApiGetConfirm();
  }

  //* ***********************************************************************************/
  // Methods
  //* ***********************************************************************************/
  clickApplyBenepo(): void {
    this.showBenp01Modal = true;
  }

  clickApplyCafePoint(): void {
    this.showCafe01Modal = true;
  }

  clickApplySubsidy(): void {
    this.showSubs01Modal = true;
  }

  submitBenp01Modal(): void {
    this.closeBenp01Modal();
    this.doApiGetConfirm();
  }

  closeBenp01Modal(): void {
    this.showBenp01Modal = false;
  }

  submitCafe01Modal(): void {
    this.closeCafe01Modal();
    this.doApiGetConfirm();
  }

  closeCafe01Modal(): void {
    this.showCafe01Modal = false;
  }

  submitSubs01Modal(): void {
    this.closeSubs01Modal();
    this.doApiGetConfirm();
  }

  closeSubs01Modal(): void {
    this.showSubs01Modal = false;
  }

  clickPay(): void {
    // validate.
    if (!this.validSubmit) return;

    // 補助金申請済判定
    if (this.resGetConfirm.orderSubsidyFlag && this.resGetConfirm.canSubsidyRequired && !this.resGetConfirm.doneApplySubsidy) {
      this.showSubs01Modal = true;
      return;
    }

    this.pay();
  }

  private pay() {
    switch (this.resGetConfirm.orderSite) {
      // 楽天
      case 1: {
        this.doApiPostConfirmRakuten();
        break;
      }
      // 通常
      case 2: {
        if (this.resGetConfirm.billingAmount === 0) {
          this.doApiPostAnaConfirmNoPayment();
        } else {
          this.doApiPostConfirmSelectPay();
        }
        break;
      }
      // JAL
      case 3: {
        this.doApiPostConfirmJal();
        break;
      }
      default:
        this.$router.push({
          name: 'Erro01',
        });
        break;
    }
  }

  doApiGetConfirm(): void {
    const params = new URL(window.location.href).searchParams;

    if (params.get('orderSite')) {
      this.orderSite = Number(params.get('orderSite'));
    } else if (this.resGetConfirm?.orderSite) {
      this.orderSite = this.resGetConfirm?.orderSite;
    }

    // 同行者申請の場合はそちらのAPIを呼び出す
    if (this.orderSite === 4) {
      this.doApiGetOrderConfirmFellowTravelers();
      return;
    }
    const config = OrderApiConfig.newInstance();
    const apiOrder = new DPApi(config);
    store.commit('setIsLoading', true);

    apiOrder
      .getConfirm()
      .then((res) => {
        this.resGetConfirm = res as OrderConfirmType;
        this.orderSite = this.resGetConfirm.orderSite;

        // orderSiteが4だったら同行者申請に切り替える
        if (this.resGetConfirm.orderSite && this.resGetConfirm.orderSite === 4) {
          this.doApiGetOrderConfirmFellowTravelers();
        }
      })
      .catch((error: unknown) => {
        if (ApiService.isErrorData(error)) {
          this.commonErrorResponse = error;
        } else {
          this.$router.push({
            name: 'Erro01',
          });
        }
      })
      .finally(() => {
        store.commit('setIsLoading', false);
      });
  }

  doApiGetOrderConfirmFellowTravelers(): void {
    const config = OrderApiConfig.newInstance();
    const apiOrder = new DPApi(config);
    store.commit('setIsLoading', true);

    apiOrder
      .getOrderConfirmFellowTravelers()
      .then((res) => {
        this.resGetConfirm = res as OrderConfirmType;
      })
      .catch((error) => {
        if (ApiService.isErrorData(error)) {
          this.commonErrorResponse = error;
        } else {
          error.json().then((res) => {
            if (error.status === 400 && res.errorDetail) {
              sessionStorage.setItem('error', res.errorDetail);
            }
            this.$router.push({
              name: 'Erro01',
            });
          });
        }
      })
      .finally(() => {
        store.commit('setIsLoading', false);
      });
  }

  doApiPostConfirmRakuten(): void {
    const config = OrderApiConfig.newInstance();
    const apiOrder = new DPApi(config);
    store.commit('setIsLoading', true);

    apiOrder
      .postRakutenConfirm()
      .then((res) => {
        this.$store.dispatch('clear');
        window.location.href = res;
      })
      .catch((error: unknown) => {
        if (ApiService.isErrorData(error)) {
          this.commonErrorResponse = error;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          this.$router.push({
            name: 'Erro01',
          });
        }
      })
      .finally(() => {
        store.commit('setIsLoading', false);
      });
  }

  doApiPostAnaConfirmNoPayment(): void {
    const config = OrderApiConfig.newInstance();
    const apiOrder = new DPApi(config);
    store.commit('setIsLoading', true);

    apiOrder
      .postAnaConfirmNoPayment()
      .then((res) => {
        this.$store.dispatch('clear');

        this.$router.push({
          name: 'Ordc01',
          params: {
            status: 'Success',
            confirmPayPostResponse: res as string,
          },
        });
      })
      .catch((error: unknown) => {
        if (ApiService.isErrorData(error)) {
          this.commonErrorResponse = error;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          this.$router.push({
            name: 'Erro01',
          });
        }
      })
      .finally(() => {
        store.commit('setIsLoading', false);
      });
  }

  doApiPostConfirmSelectPay(): void {
    const config = OrderApiConfig.newInstance();
    const apiOrder = new DPApi(config);
    store.commit('setIsLoading', true);

    const body: JpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequest = {
      userAgent: window.navigator.userAgent.toLowerCase(),
    };

    const request: PostConfirmSelectPayRequest = {
      payMthdDiv: this.selectedPaymentMethod,
      jpCoBenefitoneBsdpBffPresentationRequestSelectPayPostRequest: body,
    };

    apiOrder
      .postConfirmSelectPay(request)
      .then((res) => {
        this.$store.dispatch('clear');

        const url = new URL(EnvRepository.getEnv().VUE_APP_BENEFIT_SELECT_PAYMENT);
        url.searchParams.append('tid', res.orderRequestEncryptedTransactionId ?? '');
        window.location.href = url.href;
      })
      .catch((error: unknown) => {
        if (ApiService.isErrorData(error)) {
          this.commonErrorResponse = error;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          this.$router.push({
            name: 'Erro01',
          });
        }
      })
      .finally(() => {
        store.commit('setIsLoading', false);
      });
  }

  doApiPostConfirmJal(): void {
    const config = OrderApiConfig.newInstance();
    const apiOrder = new DPApi(config);
    store.commit('setIsLoading', true);

    apiOrder
      .postJalConfirm()
      .then((res) => {
        this.$store.dispatch('clear');

        if (res !== undefined) {
          const response = res as unknown as {
            [key: string]: string;
          };

          const convertParamsList = [
            { to: 'di', from: 'di' },
            { to: 'vc', from: 'vc' },
            { to: 'dj', from: 'dj' },
            { to: 'transactionId', from: 'TransactionId' },
            { to: 'benefitStationTmpReserveNo', from: 'Benefit_StationTmpReserveNo' },
            { to: 'subsidyInvestPrice', from: 'SubsidyInvestPrice' },
            { to: 'sessionInfo', from: 'SessionInfo' },
            { to: 'subsidyName1', from: 'SubsidyName1' },
            { to: 'subsidyInvestPrice1', from: 'SubsidyInvestPrice1' },
            { to: 'subsidyName2', from: 'SubsidyName2' },
            { to: 'subsidyInvestPrice2', from: 'SubsidyInvestPrice2' },
            { to: 'subsidyName3', from: 'SubsidyName3' },
            { to: 'subsidyInvestPrice3', from: 'SubsidyInvestPrice3' },
            { to: 'subsidyName4', from: 'SubsidyName4' },
            { to: 'subsidyInvestPrice4', from: 'SubsidyInvestPrice4' },
            { to: 'subsidyName5', from: 'SubsidyName5' },
            { to: 'subsidyInvestPrice5', from: 'SubsidyInvestPrice5' },
            { to: 'dn', from: 'dn' },
          ];

          const form = document.createElement('form');
          form.method = 'POST';
          form.action = response.nextUrl;

          convertParamsList.forEach((item) => {
            const hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = item.from;
            hiddenField.value = response[item.to];
            form.appendChild(hiddenField);
          });

          document.body.appendChild(form);
          form.submit();
        }
      })
      .catch((error: unknown) => {
        if (ApiService.isErrorData(error)) {
          this.commonErrorResponse = error;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          this.$router.push({
            name: 'Erro01',
          });
        }
      })
      .finally(() => {
        store.commit('setIsLoading', false);
      });
  }

  clickFellowTravelersOrder(): void {
    // 補助金申請済判定
    if (this.resGetConfirm.orderSubsidyFlag && this.resGetConfirm.canSubsidyRequired && !this.resGetConfirm.doneApplySubsidy) {
      this.showSubs01Modal = true;
      return;
    }

    const config = OrderApiConfig.newInstance();
    const apiOrder = new DPApi(config);
    store.commit('setIsLoading', true);

    apiOrder
      .putOrderApplyFellowTravelers()
      .then((res) => {
        this.$store.dispatch('clear');

        this.$router.push({
          name: 'Ordc01',
          params: {
            status: 'Success',
            confirmPayPostResponse: res as string,
          },
        });
      })
      .catch((error: unknown) => {
        if (ApiService.isErrorData(error)) {
          this.commonErrorResponse = error;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          this.$router.push({
            name: 'Erro01',
          });
        }
      })
      .finally(() => {
        store.commit('setIsLoading', false);
      });
  }
}
